module.exports = __webpack_public_path__ + "files/3af1a4bc6f37abf65d55733ca3b00fb5.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bold-webfont.ttf
 ** module id = 985
 ** module chunks = 0
 **/